import { lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { useAllCurrencyOptions } from '../../hooks/useAllCurrencyOptions';
import { FieldNames } from '../fieldNames';

export const CurrencyField = () => {
    const allCurrencyOptions = useAllCurrencyOptions();

    return <SelectField name={FieldNames.currency} label={lt('Currency')} required options={allCurrencyOptions} />;
};
